import { render, staticRenderFns } from "./editContent.vue?vue&type=template&id=35cf107f"
import script from "./editContent.vue?vue&type=script&lang=ts"
export * from "./editContent.vue?vue&type=script&lang=ts"
import style0 from "./editContent.vue?vue&type=style&index=0&id=35cf107f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports